var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('section',[_c('AddressForm',_vm._g({attrs:{"item":_vm.item,"errors":_vm.errors}},_vm.$listeners)),_c('MediaForm',_vm._g({attrs:{"item":_vm.item,"errors":_vm.errors}},_vm.$listeners))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }